import React, { Component } from 'react';
import SocialLogin from './SocialLogin';

import './Login.css';
import logo from '../../media/logo1.svg';

const Login = () => {
  return (
    <div className='login-wrapper'>
      <div className='form'>
        <span className='form-header'>Login</span>
        {/* <SocialLogin /> */}
        <div className='login-phone'>
          <div className='input'></div>
          <input type='text' name='phonenumber' required autoComplete='off' />
          <label htmlFor='phonenumber'></label>
        </div>
      </div>
    </div>
  );
};

export default Login;
